import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import PropTypes from 'prop-types';

function Result(props) {

  const listItems = props.quizResult.map((gift) =>
    <li>{gift}</li>
  );

  return (
    <ReactCSSTransitionGroup
      className="container result"
      component="div"
      transitionName="fade"
      transitionEnterTimeout={800}
      transitionLeaveTimeout={500}
      transitionAppear
      transitionAppearTimeout={500}
    >
      <div className="results">
        <p>Thank you for taking the GodGiftsYou spiritual gifts assessment.
        Your results below are listed in order from highest to lowest. 
        For a more detailed definition of each gift, please click{'\u00A0'}
          <a target="_blank" rel="noopener noreferrer" href="https://youruniquedesign.github.io/one_sentence_descriptions.html">here </a>
        </p>

        <ol>{listItems}</ol>

        <p>Questions: contact me at{'\u00A0'}
          <a href="mailto:godgiftsyou@gmail.com">godgiftsyou@gmail.com</a>
        </p>

        <p>May God continue to help you grow in your understanding and use of your 
        gifts as you pursue Him.</p>

        <p>Blessings,<br />Shirley</p>

        <p>Shirley Giles Davis</p>
      </div>
    </ReactCSSTransitionGroup>
  );

}

Result.propTypes = {
  quizResult: PropTypes.array.isRequired,
};

export default Result;



// WEBPACK FOOTER //
// ./src/components/Result.js